import React from 'react';

const CheckInGoogle = () => {
    return (
        <div>
            
        </div>
    );
};

export default CheckInGoogle;